var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityFairburnIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0238 8.33342C13.0238 12.4942 8.40793 16.8276 6.85793 18.1659C6.71353 18.2745 6.53776 18.3332 6.3571 18.3332C6.17643 18.3332 6.00066 18.2745 5.85626 18.1659C4.30626 16.8276 -0.30957 12.4942 -0.30957 8.33342C-0.30957 6.56531 0.392809 4.86961 1.64305 3.61937C2.89329 2.36913 4.58899 1.66675 6.3571 1.66675C8.12521 1.66675 9.8209 2.36913 11.0711 3.61937C12.3214 4.86961 13.0238 6.56531 13.0238 8.33342Z",
    stroke: "#00C49A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35718 10.8333C7.73789 10.8333 8.85718 9.71396 8.85718 8.33325C8.85718 6.95254 7.73789 5.83325 6.35718 5.83325C4.97647 5.83325 3.85718 6.95254 3.85718 8.33325C3.85718 9.71396 4.97647 10.8333 6.35718 10.8333Z",
    stroke: "#00C49A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityFairburnIcon);
export default __webpack_public_path__ + "static/media/city-fairburn-icon.8e3b9be3dce9533098ee4d4f93a67952.svg";
export { ForwardRef as ReactComponent };